import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StylingService {

  fontSmall:string = "10";
  fontMedium:string = "11";

  imageSizeSmall:string = "100";
  imageSizeMedium:string = "100";

  constructor() { }

  getFontSize(s:string):string{
    switch (s) {
      case 'small':
        return this.fontSmall;
        break;
      
        case 'medium':
          return this.fontMedium;
          break;

      default:
        break;
    }

  }

  getImageSize(s:string):string{
    switch (s) {
      case 'small':
        return this.imageSizeSmall;
        break;
      
        case 'medium':
          return this.imageSizeMedium;
          break;

      default:
        break;
    }
  }
}
